export const acceptableUseContent = {
  title: "Acceptable Use Policy",
  lastUpdated: "June 2026",
  intro: "This policy defines the standard of conduct for accessing the BizNearYou local database and matching features.",
  prohibitedHeading: "Strictly Prohibited Uses:",
  prohibitedItems: [
    {
      title: "Spam & Bulk Messaging",
      description: "Sending unsolicited mass commercial pitches or annoying outreach sequences."
    },
    {
      title: "Harassment & Stalking",
      description: "Using location details or mapping coordinates to stalk or intimidate individuals."
    },
    {
      title: "Scraping Abuse",
      description: "Extracting Businesses or job details at abusive scales to repackage or resell."
    },
    {
      title: "Deceptive Listings & Scams",
      description: "Creating fraudulent company accounts or posting misBusinessing work-at-home opportunities or phishing schemes."
    },
    {
      title: "Discrimination",
      description: "Posting roles that discriminate based on race, gender, religion, age, disability, or orientation."
    }
  ],
  conclusion: "BizNearYou reserves the right to suspend accounts or blacklist IP ranges violating these conduct guidelines immediately."
};
